type SwapValueToken = {
  derivedETH?: string | null
}

type V3SwapValueInput = {
  amountUSD?: string | null
  amount0: string
  amount1: string
  token0?: SwapValueToken
  token1?: SwapValueToken
}

export function getV3SwapUsdValue(
  swap: V3SwapValueInput,
  wcroPriceUSD: number,
  fallbackToken0?: SwapValueToken,
  fallbackToken1?: SwapValueToken
): number {
  const indexedValue = Math.abs(Number(swap.amountUSD))
  if (Number.isFinite(indexedValue) && indexedValue > 0) return indexedValue

  const token0 = swap.token0 ?? fallbackToken0
  const token1 = swap.token1 ?? fallbackToken1
  const derivedValues = [
    Math.abs(Number(swap.amount0)) * Math.abs(Number(token0?.derivedETH)) * wcroPriceUSD,
    Math.abs(Number(swap.amount1)) * Math.abs(Number(token1?.derivedETH)) * wcroPriceUSD,
  ].filter((value) => Number.isFinite(value) && value > 0)

  return derivedValues.length ? Math.max(...derivedValues) : 0
}
